import {useMap} from "@vis.gl/react-google-maps";
import {useEffect} from "react";

export default function CenterOnSelection({ passage, centerOnSelectionRef, options, currentPassage}) {
    const map = useMap();
    useEffect(() => {
        if(!centerOnSelectionRef.current) return;
        if(options.groupByPlate){
            if (!map
                || passage.type === "multiple"
                || !passage?.data?.passages[currentPassage ?? 0]?.latitude
                || !passage?.data?.passages[currentPassage ?? 0]?.longitude
            ) return;

            map.panTo({
                lat: passage?.data.passages[currentPassage ?? 0].latitude,
                lng: passage?.data.passages[currentPassage ?? 0].longitude,
            });
        }

        if(!options.groupByPlate){
            if (!map || !passage?.data?.latitude || !passage?.data?.longitude) return;

            map.panTo({
                lat: passage?.data.latitude,
                lng: passage?.data.longitude,
            });
        }

        map.setZoom(14);
        centerOnSelectionRef.current = false
    }, [map, passage, currentPassage]);

    return null;
}